import definition from './notes.service';

/**
 * NotesApi settings
 * @type {{name: string, definition: NotesApi}}
 */
export default {
    name: 'NotesApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/notes/index.js